import general from './general';
import doctor from "./doctor";

export default {
    general, doctor
}